import { type ReactNode, useCallback, useMemo, useState } from "react";
import { HelpDrawer } from "./help-drawer";
import { HelpDrawerContext } from "./help-drawer-context";
import type { HelpKey } from "../help-registry";

/**
 * Owns which help entry the one app-wide help drawer shows. The drawer keeps
 * its last entry while it slides out, so closing never flashes it empty.
 */
export function HelpDrawerProvider({ children }: { children: ReactNode }) {
	const [helpKey, setHelpKey] = useState<HelpKey | null>(null);
	const [open, setOpen] = useState(false);

	const openHelp = useCallback((key: HelpKey) => {
		setHelpKey(key);
		setOpen(true);
	}, []);

	const value = useMemo(() => ({ openHelp }), [openHelp]);

	return (
		<HelpDrawerContext.Provider value={value}>
			{children}
			{helpKey && (
				<HelpDrawer
					helpKey={helpKey}
					open={open}
					onClose={() => setOpen(false)}
				/>
			)}
		</HelpDrawerContext.Provider>
	);
}
